import {CAT_ANALYTICS, CAT_FUNCTIONALITY, CAT_NECESSARY} from "../ConsentCookieDefinitions";

// Seccion Encabezado de la Modal de Preferencias
const SECTION_PRIMARY_DEF = {
  description: `<span>Pode configurar e/ou aceitar o uso de cookies através das caixas de seleção mostradas abaixo.</span>
<span>Se desejar mais informações, pode visitar a nossa <a href="/politica-de-cookies-ue" target="_blank"><strong>Política de Cookies Ampliada</strong></a></span>
`
};

// Seccion Cookies Necesarias de la Modal de Preferencias
const SECTION_NECESSARY_DEF = {
  title: 'Técnicas (Necessárias)',
  description:'As cookies estritamente necessárias garantem funções que são indispensáveis para o funcionamento adequado do site. Como resultado, essas cookies não podem ser desativadas. São utilizadas exclusivamente neste site e, portanto, são cookies próprias. Isso significa que todas as informações armazenadas nas cookies serão enviadas apenas para este site.',
  linkedCategory: CAT_NECESSARY
}

const SECTION_FUNCTIONALITY_DEF = {
  title: 'Preferências',
  description:'As cookies de preferências permitem que o site memorize informações que alteram a forma como o site se comporta ou parece, como o seu idioma preferido ou a região em que se encontra.',
  linkedCategory: CAT_FUNCTIONALITY
};

const SECTION_ANALYTICS_DEF = {
  title: 'Analíticas',
  description:
      'As cookies estatísticas ajudam os proprietários de sites a compreender como os visitantes interagem com o site, reunindo e fornecendo informações de forma anónima.',
  linkedCategory: CAT_ANALYTICS,
};

export const CONFIGURATION_PT = {
  consentModal: {
    description:
        `Indra Sistemas S.A. utiliza cookies próprias e de terceiros com a finalidade de registar as atividades de navegação do utilizador, quantificar o número de utilizadores e realizar medições e análises estatísticas do uso que os utilizadores fazem do serviço oferecido. Pode configurar e/ou aceitar o uso de cookies através das caixas de seleção mostradas abaixo. Se desejar mais informações, pode visitar a nossa <a href='/politica-de-cookies-ue'>Política de Cookies Ampliada</a>.`,
    acceptAllBtn: 'Aceitar todos os cookies',
    acceptNecessaryBtn: 'Usar apenas os necessários',
    showPreferencesBtn: 'Configurar cookies',
  },
  preferencesModal: {
    title: 'Configuração de preferências de cookies',
    acceptAllBtn: 'Aceitar tudo',
    acceptNecessaryBtn: 'Rejeitar',
    savePreferencesBtn: 'Guardar definições',
    closeIconLabel: 'Fechar',
    sections: [
      SECTION_PRIMARY_DEF,
      SECTION_NECESSARY_DEF,
      //SECTION_FUNCTIONALITY_DEF,
      SECTION_ANALYTICS_DEF,
    ],
  },
}
